import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

// components
import DatePicker from 'material-ui/DatePicker';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import TextField from 'material-ui/TextField';
// formatters
import { FormattedDate } from 'react-intl';
// icons
import SortAlphaIcon from 'material-ui/svg-icons/av/sort-by-alpha';

// business logic
let sortMethods = {
    default: function(a, b) { return a.id - b.id; },
    fullName: function(a, b) { return a.fullName.localeCompare(b.fullName); },
    courseName: function(a, b) { return (a.courseName.localeCompare(b.courseName)); }
};
import { statusColours } from '../../constants/ColourConstants';

const ReportCourseEnrolmentProgress = React.createClass({

    getInitialState: function () {
        return {
            sortName: 'default',
            sort: sortMethods.default,
            statuses: ['waiting', 'enrolled', 'completed'],
            filters: {
                name: '',
                organisation: '',
                courseName: '',
                enrolledFrom: '',
                enrolledFromTime: 0,
                enrolledTo: '',
                enrolledToTime: 0,
                status: '',
                scoreMin: '',
                scoreMax: '',
                completedFrom: '',
                completedFromTime: '',
                completedTo: '',
                completedToTime: '',
            }
        };
    },

    style: {
        textFilter: {
            width: '100%'
        },
        dateFilter: {
            width: '100%'
        },
        dropdownFilter: {
            width: '100%'
        }
    },

    render: function() {
        let data = this.props.data
            .filter(this.filterData)
            .sort(this.state.sort);



        // TODO: filters from url clickthrough?
        const tableHeaderProps = {
            enableSelectAll:   this.props.display.enableSelectAll,
            displaySelectAll:  this.props.display.enableSelectAll,
            adjustForCheckbox: this.props.display.enableSelectAll
        };
        const tableProps = {
            height:             this.props.display.height,
            fixedHeader:        this.props.display.fixedHeader,
            fixedFooter:        this.props.display.fixedFooter,
            displayRowCheckbox: !!this.props.showCheckboxes,
            selectable:         this.props.display.selectable,
            multiSelectable:    this.props.display.multiSelectable,
        };
        const tableBodyProps = {
            deselectOnClickaway: this.props.display.deselectOnClickaway,
            displayRowCheckbox:  this.props.display.showCheckboxes,
            showRowHover:        this.props.display.showRowHover,
            stripedRows:         this.props.display.stripedRows,
        };
        const dateProps = {
            year:    'numeric',
            month:   'long',
            day:     'numeric'
        };

        if (!!this.props.onRowSelect) {
            tableProps.onRowSelection = this.props.onRowSelect;
        }
        const textFilterProps = {
            hintText: 'Filter',
            onChange: this.setTextFilter,
            style:    this.style.textFilter
        };

        const dropdownFilterProps = {
            hintText: 'Filter',
            onChange: this.setDropdownFilter,
            style:    this.style.dropdownFilter
        };

        const minFilterProps = {
            hintText: 'Minimum',
            onChange: this.setTextFilter,
            style:    this.style.textFilter
        };
        if (this.state.filters.scoreMin !== '' && isNaN(Number(this.state.filters.scoreMin))) {
            minFilterProps.errorText = 'Please enter a number';
        }
        const maxFilterProps = {
            hintText: 'Maximum',
            onChange: this.setTextFilter,
            style:    this.style.textFilter
        };
        if (this.state.filters.scoreMax !== '' && isNaN(Number(this.state.filters.scoreMax))) {
            maxFilterProps.errorText = 'Please enter a number';
        }
        const dateFilterProps = {
            formatDate:     this._formatDate,
            style:          this.style.dateFilter,
            textFieldStyle: this.style.dateFilter,
        };

        return (
            <Table {...tableProps} >
                <TableHeader {...tableHeaderProps} >
                    <TableRow>
                        <TableHeaderColumn>
                            Name
                            <IconButton onTouchTap={this._setSort('fullName')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Organisation</TableHeaderColumn>
                        <TableHeaderColumn>Course
                            <IconButton onTouchTap={this._setSort('courseName')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Enrolment</TableHeaderColumn>
                        <TableHeaderColumn>Status</TableHeaderColumn>
                        <TableHeaderColumn className="tbl-td-number">Score</TableHeaderColumn>
                        <TableHeaderColumn>Completed</TableHeaderColumn>
                    </TableRow>
                    <TableRow>
                        <TableHeaderColumn>
                            <TextField name="name" value={this.state.filters.name} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="organisation" value={this.state.filters.organisation} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="courseName" value={this.state.filters.courseName} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <DatePicker hintText="From" onChange={this.setEnrolledFromFilter} {...dateFilterProps} />
                            <DatePicker hintText="To"   onChange={this.setEnrolledToFilter}   {...dateFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <SelectField name="status" value={this.state.filters.status} {...dropdownFilterProps} onChange={this.setStatusFilter} >
                                <MenuItem value="" primaryText="No filter" label=" " />
                                {this.state.statuses.map(function(status, index) {
                                    return <MenuItem key={index} value={status} primaryText={status} />;
                                })}
                            </SelectField>
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="scoreMin" value={this.state.filters.scoreMin} {...minFilterProps} /><br />
                            <TextField name="scoreMax" value={this.state.filters.scoreMax} {...maxFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <DatePicker hintText="From" onChange={this.setCompletedFromFilter} {...dateFilterProps} />
                            <DatePicker hintText="To"   onChange={this.setCompletedToFilter}   {...dateFilterProps} />
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody {...tableBodyProps} >
                    {data.map(function (row, index) {
                        let courseName = row.courseName + ' (' + row.courseCode + ')';
                        let dateEnrolled = '';
                        if (!!row.dateEnrolled) {
                            dateEnrolled = <FormattedDate {...dateProps} value={row.dateEnrolled} />;
                        }

                        let dateCompleted = '';
                        if (!!row.dateCompleted) {
                            dateCompleted = <FormattedDate {...dateProps} value={row.dateCompleted} />;
                        }

                        let organisations = this.getList(row.organisations);
                        let orgTitle = row.organisations.replace(/\|/g, "\n");

                        return (
                            <TableRow key={index} selected={row.selected} style={{color: !row.archived ? statusColours.default : statusColours.waiting}}>
                                <TableRowColumn>
                                    <Link to={`/dashboard/user/${row.userId}`}>
                                        {!row.archived
                                            ? row.fullName
                                            : <span title="Archived user">{row.fullName}</span>
                                        }
                                    </Link>
                                </TableRowColumn>
                                <TableRowColumn title={orgTitle} >{organisations}</TableRowColumn>
                                <TableRowColumn>{courseName}</TableRowColumn>
                                <TableRowColumn>{dateEnrolled}</TableRowColumn>
                                <TableRowColumn>{row.status}</TableRowColumn>
                                <TableRowColumn className="tbl-td-number">{row.score}</TableRowColumn>
                                <TableRowColumn>{dateCompleted}</TableRowColumn>
                            </TableRow>
                        );
                    }, this)}
                </TableBody>

            </Table>
        );
    },

    _setSort: function(sort) {
        let _sort = sort;
        let self = this;
        return function() {
            if (sortMethods.hasOwnProperty(_sort) && self.state.sortName !== _sort) {
                self.setState({sortName: _sort, sort: sortMethods[_sort]});
            }
        };
    },

    setTextFilter: function(event) {
        this._setFilter(event.target.name, event.target.value.toLocaleLowerCase());
    },

    setStatusFilter: function(event, i, value) {
        this._setFilter('status', value);
    },

    setEnrolledFromFilter: function(event, value) {
        this._setFilter('enrolledFrom', value);
    },

    setEnrolledToFilter: function(event, value) {
        this._setFilter('enrolledTo', value);
    },

    setCompletedFromFilter: function(event, value) {
        this._setFilter('completedFrom', value);
    },

    setCompletedToFilter: function(event, value) {
        this._setFilter('completedTo', value);
    },

    _setFilter: function(filter, value) {
        if (this.state.filters.hasOwnProperty(filter)) {
            let filters = this.state.filters;
            filters[filter] = value ;
            if (filters.hasOwnProperty(filter + 'Time')) {
                filters[filter + 'Time'] = (value instanceof Date ? value.getTime() : '');
            }
            this.setState({filters: filters});
        }
    },

    filterData: function(row) {
        let valid = (row !== undefined);
        if (valid && !!this.state.filters.name) {
            valid = (-1 < row.fullName.toLocaleLowerCase().search(this.state.filters.name));
        }

        if (valid && !!this.state.filters.organisation) {
            valid = (-1 < row.organisations.toLocaleLowerCase().search(this.state.filters.organisation));
        }

        if (valid && !!this.state.filters.courseName) {
            valid = (-1 < row.courseName.toLocaleLowerCase().search(this.state.filters.courseName));
        }

        if (valid && !!this.state.filters.status) {
            valid = row.status === this.state.filters.status;
        }

        if (valid && this.state.filters.scoreMin !== '' && !isNaN(Number(this.state.filters.scoreMin))) {
            valid = (this.state.filters.scoreMin <= row.score);
        }

        if (valid && this.state.filters.scoreMax !== '' && !isNaN(Number(this.state.filters.scoreMax))) {
            valid = (row.score <= this.state.filters.scoreMax);
        }

        let enrolled = (new Date(row.dateEnrolled)).setHours(0, 0, 0);

        if (valid && !!this.state.filters.enrolledFrom) {
            valid = (this.state.filters.enrolledFromTime <= enrolled);
        }
        if (valid && !!this.state.filters.enrolledTo) {
            valid = ( enrolled <= this.state.filters.enrolledToTime );
        }

        let completed = false;
        if (row.dateCompleted !== null) {
            completed = (new Date(row.dateCompleted)).setHours(0, 0, 0);
        }

        if (valid && !!this.state.filters.completedFrom) {
            valid = (!!completed && this.state.filters.completedFromTime <= completed);
        }

        if (valid && !!this.state.filters.completedTo) {
            valid = (!!completed && completed <= this.state.filters.completedToTime );
        }
        return valid;
    },

    _formatDate: function(date) {
        if(date instanceof Date) {
            return new Intl.DateTimeFormat().format(date);
        }
    },

    getList: function (line, separator) {
        let list = '';
        let spanProps = {
            style: {
                marginRight: '1em'
            },
            className: 'inline-list'
        };
        if (!!line) {
            list = line.split(separator || '|')
                .map(function (e, i) {
                    return <span key={i} {...spanProps} >{e}</span>;
                });
        }
        return list;
    }

});

ReportCourseEnrolmentProgress.propTypes = {
    display: PropTypes.object,
    onRowSelect: PropTypes.func,
    data: PropTypes.arrayOf(PropTypes.object),
};

ReportCourseEnrolmentProgress.defaultProps = {
    display: {
        fixedHeader: true,
        fixedFooter: true,
        stripedRows: false,
        showRowHover: false,
        showCheckboxes: false,
        selectable: false,
        multiSelectable: false,
        enableSelectAll: false,
        deselectOnClickaway: false,
    },
    data: []
};

export default ReportCourseEnrolmentProgress;


